import {
  GET_FOOD_TABLE_WIDGET_RENDER_DATA,
  GET_FOOD_TABLE_WIDGET_RENDER_DATA_SUCCESS,
  GET_FOOD_TABLE_WIDGET_RENDER_DATA_ERROR,
  POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY,
  POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_SUCCESS,
  POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_ERROR,
  POST_FOOD_TABLE_WIDGET_BOOK,
  POST_FOOD_TABLE_WIDGET_BOOK_SUCCESS,
  POST_FOOD_TABLE_WIDGET_BOOK_ERROR,
  GET_FOOD_TABLE_WIDGET_LIST,
  GET_FOOD_TABLE_WIDGET_LIST_SUCCESS,
  GET_FOOD_TABLE_WIDGET_LIST_ERROR,
  GET_FOOD_TABLE_WIDGET_DATA,
  GET_FOOD_TABLE_WIDGET_DATA_SUCCESS,
  GET_FOOD_TABLE_WIDGET_DATA_ERROR,
  POST_FOOD_TABLE_WIDGET_CREATE,
  POST_FOOD_TABLE_WIDGET_CREATE_SUCCESS,
  POST_FOOD_TABLE_WIDGET_CREATE_ERROR,
  PUT_FOOD_TABLE_WIDGET_UPDATE,
  PUT_FOOD_TABLE_WIDGET_UPDATE_SUCCESS,
  PUT_FOOD_TABLE_WIDGET_UPDATE_ERROR,
  DELETE_FOOD_TABLE_WIDGET_DELETE,
  DELETE_FOOD_TABLE_WIDGET_DELETE_SUCCESS,
  DELETE_FOOD_TABLE_WIDGET_DELETE_ERROR,
  GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH,
  GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_SUCCESS,
  GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_ERROR,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_SUCCESS,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_ERROR,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_SUCCESS,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_ERROR,
  GET_FOOD_TABLE_WIDGET_SEARCH,
  GET_FOOD_TABLE_WIDGET_SEARCH_SUCCESS,
  GET_FOOD_TABLE_WIDGET_SEARCH_ERROR,
  GET_PAYMENT_REQUEST_PUBLIC_DATA,
  GET_PAYMENT_REQUEST_PUBLIC_DATA_SUCCESS,
  GET_PAYMENT_REQUEST_PUBLIC_DATA_ERROR,
  GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA,
  GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_SUCCESS,
  GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_ERROR,
  POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL,
  POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_SUCCESS,
  POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_ERROR,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_SUCCESS,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_ERROR,
  GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW,
  GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_SUCCESS,
  GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_ERROR,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_SUCCESS,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_ERROR,
} from "./actionType";

const initialData = {
  foodTableWidgetRenderData: [],
  foodTableWidgetRenderDataLoading: false,

  foodTableWidgetCheckAvailabilityData: [],
  foodTableWidgetCheckAvailabilityDataLoading: false,

  foodTableWidgetBookData: [],
  foodTableWidgetBookDataLoading: false,

  foodTableWidgetListData: [],
  foodTableWidgetListDataLoading: false,

  foodTableWidgetData: [],
  foodTableWidgetDataLoading: false,

  foodTableWidgetCreateData: [],
  foodTableWidgetCreateDataLoading: false,

  foodTableWidgetUpdateData: [],
  foodTableWidgetUpdateDataLoading: false,

  foodTableWidgetDeleteData: [],
  foodTableWidgetDeleteDataLoading: false,

  foodTableReservationTableAssignmentActivityLogSearchData: [],
  foodTableReservationTableAssignmentActivityLogSearchDataLoading: false,

  //POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK
  foodTableReservationTableAssignmentLockData: [],
  foodTableReservationTableAssignmentLockDataLoading: false,

  //POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK
  foodTableReservationTableAssignmentUnlockData: [],
  foodTableReservationTableAssignmentUnlockDataLoading: false,

  //GET_FOOD_TABLE_WIDGET_SEARCH
  foodTableWidgetSearchData: [],
  foodTableWidgetSearchDataLoading: false,
  //GET_PAYMENT_REQUEST_PUBLIC_DATA
  paymentRequestPublicData: [],
  paymentRequestPublicDataLoading: false,
  foodTableWidgetCreateUpdateDataLoading: false,
  //GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA
  foodTableReservationPublicRenderData: [],
  foodTableReservationPublicRenderDataLoading: false,
  //POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL
  foodTableReservationPublicCancelData: [],
  foodTableReservationPublicCancelDataLoading: false,
  //Task 24278 - request-to-book approve / decline
  foodTableReservationRequestApproveData: [],
  foodTableReservationRequestApproveDataLoading: false,
  foodTableReservationRequestDeclinePreviewData: [],
  foodTableReservationRequestDeclinePreviewDataLoading: false,
  foodTableReservationRequestDeclineData: [],
  foodTableReservationRequestDeclineDataLoading: false,
};

//Reducer
const BookATable = (state = initialData, action) => {
  switch (action.type) {
    case GET_FOOD_TABLE_WIDGET_RENDER_DATA:
      return {
        ...state,
        foodTableWidgetRenderDataLoading: true,
      };
    case GET_FOOD_TABLE_WIDGET_RENDER_DATA_SUCCESS:
      return {
        ...state,
        foodTableWidgetRenderData: action.payload,
        foodTableWidgetRenderDataLoading: false,
      };
    case GET_FOOD_TABLE_WIDGET_RENDER_DATA_ERROR:
      return {
        ...state,
        foodTableWidgetRenderDataLoading: false,
      };
    case POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY:
      return {
        ...state,
        foodTableWidgetCheckAvailabilityDataLoading: true,
      };
    case POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        foodTableWidgetCheckAvailabilityData: action.payload,
        foodTableWidgetCheckAvailabilityDataLoading: false,
      };
    case POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_ERROR:
      return {
        ...state,
        foodTableWidgetCheckAvailabilityDataLoading: false,
      };
    case POST_FOOD_TABLE_WIDGET_BOOK:
      return {
        ...state,
        foodTableWidgetBookDataLoading: true,
      };
    case POST_FOOD_TABLE_WIDGET_BOOK_SUCCESS:
      return {
        ...state,
        foodTableWidgetBookData: action.payload,
        foodTableWidgetBookDataLoading: false,
      };
    case POST_FOOD_TABLE_WIDGET_BOOK_ERROR:
      // Change #100657 - a 500 used to be dropped here, so Create Booking just
      // stopped doing anything. Hand the screens a failure they already show.
      return {
        ...state,
        foodTableWidgetBookData: {
          status: 500,
          message: "Could not create that booking - please try again",
        },
        foodTableWidgetBookDataLoading: false,
      };
    case GET_FOOD_TABLE_WIDGET_LIST:
      return {
        ...state,
        foodTableWidgetListDataLoading: true,
      };
    case GET_FOOD_TABLE_WIDGET_LIST_SUCCESS:
      return {
        ...state,
        foodTableWidgetListData: action.payload,
        foodTableWidgetListDataLoading: false,
      };
    case GET_FOOD_TABLE_WIDGET_LIST_ERROR:
      return {
        ...state,
        foodTableWidgetListDataLoading: false,
      };
    case GET_FOOD_TABLE_WIDGET_DATA:
      return {
        ...state,
        foodTableWidgetDataLoading: true,
      };
    case GET_FOOD_TABLE_WIDGET_DATA_SUCCESS:
      return {
        ...state,
        foodTableWidgetData: action.payload,
        foodTableWidgetDataLoading: false,
      };
    case GET_FOOD_TABLE_WIDGET_DATA_ERROR:
      return {
        ...state,
        foodTableWidgetDataLoading: false,
      };
    case POST_FOOD_TABLE_WIDGET_CREATE:
      return {
        ...state,
        foodTableWidgetCreateUpdateDataLoading: true,
      };
    case POST_FOOD_TABLE_WIDGET_CREATE_SUCCESS:
      return {
        ...state,
        foodTableWidgetCreateData: action.payload,
        foodTableWidgetCreateUpdateDataLoading: false,
      };
    case POST_FOOD_TABLE_WIDGET_CREATE_ERROR:
      return {
        ...state,
        foodTableWidgetCreateUpdateDataLoading: false,
      };
    case PUT_FOOD_TABLE_WIDGET_UPDATE:
      return {
        ...state,
        foodTableWidgetCreateUpdateDataLoading: true,
      };
    case PUT_FOOD_TABLE_WIDGET_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableWidgetUpdateData: action.payload,
        foodTableWidgetCreateUpdateDataLoading: false,
      };
    case PUT_FOOD_TABLE_WIDGET_UPDATE_ERROR:
      return {
        ...state,
        foodTableWidgetCreateUpdateDataLoading: false,
      };
    case DELETE_FOOD_TABLE_WIDGET_DELETE:
      return {
        ...state,
        foodTableWidgetDeleteDataLoading: true,
      };
    case DELETE_FOOD_TABLE_WIDGET_DELETE_SUCCESS:
      return {
        ...state,
        foodTableWidgetDeleteData: action.payload,
        foodTableWidgetDeleteDataLoading: false,
      };
    case DELETE_FOOD_TABLE_WIDGET_DELETE_ERROR:
      return {
        ...state,
        foodTableWidgetDeleteDataLoading: false,
      };
    case GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH:
      return {
        ...state,
        foodTableReservationTableAssignmentActivityLogSearchDataLoading: true,
      };
    case GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentActivityLogSearchData:
          action.payload,
        foodTableReservationTableAssignmentActivityLogSearchDataLoading: false,
      };
    case GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_ERROR:
      return {
        ...state,
        foodTableReservationTableAssignmentActivityLogSearchDataLoading: false,
      };

    case POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK:
      return {
        ...state,
        foodTableReservationTableAssignmentLockDataLoading: true,
      };
    case POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentLockData: action.payload,
        foodTableReservationTableAssignmentLockDataLoading: false,
      };
    case POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_ERROR:
      return {
        ...state,
        foodTableReservationTableAssignmentLockDataLoading: false,
      };
    case POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK:
      return {
        ...state,
        foodTableReservationTableAssignmentUnlockDataLoading: true,
      };
    case POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentUnlockData: action.payload,
        foodTableReservationTableAssignmentUnlockDataLoading: false,
      };
    case POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_ERROR:
      return {
        ...state,
        foodTableReservationTableAssignmentUnlockDataLoading: false,
      };
    case GET_FOOD_TABLE_WIDGET_SEARCH:
      return {
        ...state,
        foodTableWidgetSearchDataLoading: true,
      };
    case GET_FOOD_TABLE_WIDGET_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableWidgetSearchData: action.payload,
        foodTableWidgetSearchDataLoading: false,
      };
    case GET_FOOD_TABLE_WIDGET_SEARCH_ERROR:
      return {
        ...state,
        foodTableWidgetSearchDataLoading: false,
      };
    case GET_PAYMENT_REQUEST_PUBLIC_DATA:
      return {
        ...state,
        paymentRequestPublicDataLoading: true,
      };
    case GET_PAYMENT_REQUEST_PUBLIC_DATA_SUCCESS:
      return {
        ...state,
        paymentRequestPublicData: action.payload,
        paymentRequestPublicDataLoading: false,
      };
    case GET_PAYMENT_REQUEST_PUBLIC_DATA_ERROR:
      return {
        ...state,
        paymentRequestPublicDataLoading: false,
      };
    case GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA:
      return {
        ...state,
        foodTableReservationPublicRenderDataLoading: true,
      };
    case GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_SUCCESS:
      return {
        ...state,
        foodTableReservationPublicRenderData: action.payload,
        foodTableReservationPublicRenderDataLoading: false,
      };
    case GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_ERROR:
      return {
        ...state,
        foodTableReservationPublicRenderDataLoading: false,
      };
    case POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL:
      return {
        ...state,
        foodTableReservationPublicCancelDataLoading: true,
      };
    case POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_SUCCESS:
      return {
        ...state,
        foodTableReservationPublicCancelData: action.payload,
        foodTableReservationPublicCancelDataLoading: false,
      };
    case POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_ERROR:
      return {
        ...state,
        foodTableReservationPublicCancelDataLoading: false,
      };

    // Task 24278 - request-to-book approve
    case PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE:
      return {
        ...state,
        foodTableReservationRequestApproveDataLoading: true,
      };
    case PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_SUCCESS:
      return {
        ...state,
        foodTableReservationRequestApproveData: action.payload,
        foodTableReservationRequestApproveDataLoading: false,
      };
    case PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_ERROR:
      return {
        ...state,
        foodTableReservationRequestApproveDataLoading: false,
      };

    // Task 24278 - request-to-book decline preview
    case GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW:
      return {
        ...state,
        foodTableReservationRequestDeclinePreviewDataLoading: true,
      };
    case GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_SUCCESS:
      return {
        ...state,
        foodTableReservationRequestDeclinePreviewData: action.payload,
        foodTableReservationRequestDeclinePreviewDataLoading: false,
      };
    case GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_ERROR:
      return {
        ...state,
        foodTableReservationRequestDeclinePreviewDataLoading: false,
      };

    // Task 24278 - request-to-book decline
    case PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE:
      return {
        ...state,
        foodTableReservationRequestDeclineDataLoading: true,
      };
    case PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_SUCCESS:
      return {
        ...state,
        foodTableReservationRequestDeclineData: action.payload,
        foodTableReservationRequestDeclineDataLoading: false,
      };
    case PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_ERROR:
      return {
        ...state,
        foodTableReservationRequestDeclineDataLoading: false,
      };

    default:
      return state;
  }
};

export default BookATable;
